import { integrationsApi } from '@carboncopyco/data';
import { DownOutlineIcon, PlayIcon } from '@carboncopyco/icons';
import { Button, Separator } from '@carboncopyco/ui';
import {
  AnalyticsTrackEventName,
  isDesktop,
  useAnalytics,
} from '@carboncopyco/utils';
import { useBoolean } from 'ahooks';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DemoPageActionsDropdown } from '../../AssetActions/Demo';
import { GiveADemoModal } from '../../PresentationModals';
import { useDemoOrOverlayProps } from '../useDemoOrOverlayProps';
import { DemoShareDropdownMenu } from './DemoShareDropdownMenu';

export const DemoPageActionButtons = () => {
  const prefetchIntegrations = integrationsApi.usePrefetch('getIntegrations');
  const [
    showGiveADemoModal,
    { setTrue: setShowGiveADemoModal, setFalse: setHideGiveADemoModal },
  ] = useBoolean();
  const {
    goToLinksTab,
    handleCreatePresentation,
    goToDemoPreview,
    demoId,
    organizationId,
    rootPath,
    playPresentation,
    desktopDomain,
    workspaceId,
    readOnly,
  } = useDemoOrOverlayProps();

  useEffect(() => {
    prefetchIntegrations({
      organizationId: Number(organizationId),
    });
  }, [prefetchIntegrations, organizationId]);

  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();
  return (
    <div className="flex items-center gap-3">
      <DemoPageActionsDropdown
        goToShares={goToLinksTab}
        {...useDemoOrOverlayProps()}
        asChild
        arrow
        align="center"
        triggerElement={
          <Button
            link
            blue
            rightIcon={<DownOutlineIcon />}
            label="Actions"
          />
        }
      />
      <div className="h-7 pr-2">
        <Separator />
      </div>
      <DemoShareDropdownMenu
        readOnly={readOnly}
        workspaceId={workspaceId}
        organizationId={organizationId}
        demoId={demoId}
        goToLinksTab={goToLinksTab}
        location="demo page"
      />
      <Button
        onClick={() => {
          trackEvent(AnalyticsTrackEventName.DEMO_CLICK_PRESENT, {
            location: 'demo_info_page_top_actions',
          });
          if (isDesktop()) {
            handleCreatePresentation?.();
            return;
          }
          setShowGiveADemoModal();
        }}
        leftIcon={<PlayIcon />}
        label="Give a demo"
      />
      {showGiveADemoModal && (
        <GiveADemoModal
          workspaceId={workspaceId}
          onClose={setHideGiveADemoModal}
          open={showGiveADemoModal}
          demoId={demoId}
          organizationId={organizationId}
          goToDemoPreview={goToDemoPreview}
          goToPresentationPage={playPresentation}
          goToDemoPresentations={() => {
            navigate(`${rootPath}/presentations`);
          }}
          desktopDomain={desktopDomain}
        />
      )}
    </div>
  );
};
